import { authFetch } from "../authFetch";

export const getAllTestType = async () => {
    try {
        const response = await authFetch(`route/getalltesttype`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
};